import { ModuleOutputKeyEnum } from "@packages/flow-core/module";
import { FlowNodeOutputTypeEnum } from "@packages/flow-core/module/node/constants";
import { FlowNodeOutputItemType } from "@packages/flow-core/module/node/types";
import { useMemo } from "react";
import Label from "./Label";
import styles from "./index.less";

export type Props = {
  moduleId: string;
  flowOutputList: FlowNodeOutputItemType[];
};

export default function RenderOutput({ moduleId, flowOutputList }: Props) {
  const sortOutputs = useMemo(
    () =>
      [...flowOutputList].sort((a, b) => {
        if (a.type === FlowNodeOutputTypeEnum.addOutputParam) {
          return 1;
        }
        if (b.type === FlowNodeOutputTypeEnum.addOutputParam) {
          return -1;
        }

        if (a.key === ModuleOutputKeyEnum.finish) return -1;
        if (b.key === ModuleOutputKeyEnum.finish) return 1;
        return 0;
      }),
    [flowOutputList]
  );

  return sortOutputs.map((output) => {
    return (
      output.type !== FlowNodeOutputTypeEnum.hidden && (
        <div key={output.key} className={styles.item}>
          {output.label && (
            <Label
              moduleId={moduleId}
              outputKey={output.key}
              outputs={sortOutputs}
              {...output}
            />
          )}
        </div>
      )
    );
  });
}
